import React, { Component } from 'react';
import store from '../store';
import ProgressDetailView from '../pages/Progress/ProgressDetailView';
import ProgressDetailEdit from '../pages/Progress/ProgressDetailEdit';
import ProgressDetailConfirm from '../pages/Progress/ProgressDetailConfirm';
import { HandleSubmit } from '../func/HandleSubmit'

const StatusNum = {
    prepishfactor: 5,
    pishfactor: 10,
    factor: 20,
    tahvil: 30,
    preafzayesh: 55,
    laghv: 40,
    afzayesh: 60,
}
class TableOfRequest extends Component {
    reqest_number = "";
    myRef = [];
    constructor(props) {
        super(props);
        this.state = {
            TableOfRequest: 'none',
            TableRow: [],
            Loading: true,
            show_rem_row: [],
            show_view_row: [],
            SubPage: this.props.subpage,
            Action: "",
            SendParameters: {},
            ShowButton: {
                view: "none",
                edit: "none",
                confirm: "none",
                cancel: "none",
            }
        };
        this.GetTableOfRequest = this.GetTableOfRequest.bind(this);
        this.YesFunc = this.YesFunc.bind(this);
        this.NoFunc = this.NoFunc.bind(this);
        this.CreateRow = this.CreateRow.bind(this);
        this.AccessButton = this.AccessButton.bind(this);
    }
    NoFunc(index) {
        this.state.show_rem_row[index] = false;
        this.setState({
            show_rem_row: this.state.show_rem_row
        });
    }
    async YesFunc(ReqNum) {
        //////////////////
        const index1 = this.state.TableRow.findIndex(item => ((item.ReqNum === ReqNum)));
        this.state.TableRow[index1].Row =
            <React.Fragment>
                <td>{index1 + 1}</td><td colSpan="3"> در حال بارگزاری</td>
            </React.Fragment>;
        this.state.SendParameters['request_code'] = ReqNum;
        //this.state.SendParameters['progress'] = 'cancel';
        this.state.SendParameters['progress'] = '35';
        this.state.SendParameters['action'] = 'confirm';
        this.state.SendParameters['detail'] = {};
        this.setState({
            SendParameters: this.state.SendParameters
        });
        let url = 'confirm/confirmrequest';
        var response_info = await HandleSubmit(url, this.state.SendParameters);
        console.log("response_info: ", response_info);
        if (response_info.status === "OK" && response_info.request_code > 0) {
            const index1 = this.state.TableRow.findIndex(item => ((item.ReqNum === ReqNum)));
            this.state.TableRow[index1].Row =
                <React.Fragment>
                    <td>{index1 + 1}</td><td colSpan="3">  درخواست شماره {ReqNum} حذف گردید</td>
                </React.Fragment>;
            this.state.show_view_row[index1] = false;
            this.state.show_rem_row[index1] = false;
            this.setState({
                TableRow: this.state.TableRow,
                show_rem_row: this.state.show_rem_row
            });
        }
    }
    async GetTableOfRequest() {
        console.log("Shod2.");
        var response_info = await HandleSubmit('getdata/gettableofrequest', { progress: this.props.progress });
        //console.log(response);
        console.log("Shod.", response_info);
        this.setState({
            TableOfPishfactor: (response_info),
        });
    }
    CreateRow() {
        this.AccessButton();
        let counter = 0;
        //myRef = React.createRef();
        for (let item of this.state.TableOfPishfactor) {
            this.state.TableRow.push({
                ReqNum: item.request_code,
                RowDate: item.date,
                RowNum: item.row,
                Row: <React.Fragment>
                    <td><button ref={(ref) => this.myRef[item.row] = ref} className="btn btn-outline-warning" style={{ "display": this.state.ShowButton.view }} onClick={
                        () => (this.ShowDetail(item.request_code, "view", item))
                    }>+</button></td>
                    <td>{counter + 1}</td>
                    <td>{item.request_code}</td>
                    <td>{item.request_owner}</td>
                    <td>{item.user_name}</td>

                    <td>{item.date}</td>
                    <td>{item.desc}</td>

                    <td><button className="btn btn-outline-warning" style={{ "display": this.state.ShowButton.edit }} onClick={
                        () => (this.ShowDetail(item.request_code, "edit", item))
                    }>ویرایش </button></td>
                    <td><button className="btn btn-outline-success" style={{ "display": this.state.ShowButton.confirm }} onClick={
                        () => (this.ShowDetail(item.request_code, "confirm", item))
                    }>تایید </button></td>
                    <td><button className="btn btn-outline-danger" style={{ "display": this.state.ShowButton.cancel }} onClick={
                        () => (this.state.show_rem_row[item.row] = true, this.setState({ show_rem_row: this.state.show_rem_row }))
                    }>لغو </button></td>
                </React.Fragment>
            });
            this.state.show_rem_row[item.row] = false;
            this.state.show_view_row[item.row] = false;
            //console.log("counter", counter + ":" + this.state.show_view_row[item.row]);
            counter++;
        }
        this.setState({
            TableRow: this.state.TableRow,
            show_rem_row: this.state.show_rem_row
        });
    }
    ShowDetail(req_num, action, item) {
        this.reqest_number = req_num;
        if (action == "view") {
            this.state.show_view_row[item.row] = !this.state.show_view_row[item.row];
            this.myRef[item.row].innerText = this.state.show_view_row[item.row] == true ? "-" : "+";
            this.setState({
                show_view_row: this.state.show_view_row,
                Action: action,
                Items: item
            });
        }
        else {
            this.setState({
                SubPage: 'detail',
                Action: action,
                Items: item
            });
        }
    }
    GetStatusCode(StatusName) {
        switch (StatusName) {
            case "pishfactor":
                return 10;
            case "factor":
                return 20;
            default:
                break;
        }
    }
    AccessButton() {
        let AccessConfig = JSON.parse(this.props.access);
        console.log("this.props.access: ", JSON.parse(this.props.access));
        console.log("this.props.progress: ", this.props.progress);
        console.log("this.props.nextprogress: ", this.props.nextprogress);
        var view_state = AccessConfig.view[(this.props.progress)];
        var edit_state = AccessConfig.edit[(this.props.progress)];
        var confirm_state = AccessConfig.confirm[(this.props.nextprogress)];
        var cancel_state = AccessConfig.confirm[(this.props.progress)];
        this.setState({
            ShowButton: {
                view: view_state == "user" || view_state == "all" ? "unset" : "none",
                edit: edit_state == "user" || edit_state == "all" ? "unset" : "none",
                confirm: confirm_state == "user" || confirm_state == "all" ? "unset" : "none",
                cancel: cancel_state == "user" || cancel_state == "all" ? "unset" : "none",
            }
        });
        //console.log("accessbut: ",AccessConfig);
        console.log("button: ", this.state.ShowButton);
    }
    async componentDidMount() {
        store.dispatch({ type: 'confirmfactors' });
        await this.GetTableOfRequest();
        this.CreateRow();
        this.setState({
            Loading: false
        });

    }
    componentWillReceiveProps() {
        this.setState({
            SubPage: this.props.subpage
        });
    }
    render() {
        if (this.state.Loading) { return "در حال بارگزاری..."; }
        switch (this.state.SubPage) {
            case 'main': {
                return (
                    <div>
                        <div style={{
                            fontSize: "24px",
                            color: "red",
                            border: "3px solid rgba(0, 150, 255, 0.91)",
                            borderRadius: "10px",
                        }}>{(this.props.progress === StatusNum.pishfactor) ? " اصلاح و تایید سفارش ها " : ""}
                            {(this.props.progress === StatusNum.factor) ? "  صدور حواله های خروج " : ""}</div>
                        <table className="table-responsive table-bordered table-striped">
                            <tbody>
                                <tr>
                                    <th></th>
                                    <th>#</th>
                                    <th>شماره سفارش </th>
                                    <th>صاحب سفارش  </th>
                                    <th>اقدام کننده </th>
                                    <th>تاریخ</th>
                                    <th>توضیحات</th>

                                </tr>
                                {this.state.TableRow.map(
                                    (item, index) => (
                                        <React.Fragment key={index}>
                                            <tr>{item.Row}</tr>
                                            {this.state.show_rem_row[index] === true ? <RemRow ReqNum={item.ReqNum} no={() => this.NoFunc(item.RowNum)} yes={() => this.YesFunc(item.ReqNum)} /> : null}
                                            {this.state.show_view_row[index] === true ? <tr style={{ borderRadius: "4px", outline: "solid thin" }}><td colSpan="9">
                                                <ProgressDetailView progress={this.props.progress} nextprogress={this.props.nextprogress}
                                                    request_code={this.reqest_number} action={this.state.Action}
                                                    items={this.state.Items}
                                                />

                                            </td></tr> : null}
                                        </React.Fragment>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div >
                );
                break;
            }
            case 'detail': {
                return (
                    <div>
                        <div style={{
                            fontSize: "24px",
                            color: "red",
                            border: "2px solid rgba(0, 150, 255, 0.91)",
                            borderRadius: "10px",
                        }}>{(this.props.progress === StatusNum.pishfactor) ? " اصلاح و تایید سفارش ها " : ""}
                            {(this.props.progress === StatusNum.factor) ? "  صدور حواله های خروج " : ""}</div>
                        {this.state.Action == "edit" ?
                            <ProgressDetailEdit progress={this.props.progress} request_code={this.reqest_number} /> : null}
                        {this.state.Action == "confirm" ?
                            <ProgressDetailConfirm progress={this.props.progress} request_code={this.reqest_number} /> : null}
                    </div>
                )
            }
            default: {
                return null;
            }
        }
    }
}
export default (TableOfRequest);

class RemRow extends Component {
    styles = {
        table: {
            textAlign: 'right',
            borderTop: "0px solid black",
            padding: "3px 20px"
        }
    }
    constructor(props) {
        super(props);
    }
    render() {
        if (this.props.Loading) { return "در حال بارگزاری..."; }
        return (
            <React.Fragment>
                <tr><td style={this.styles.table} colSpan="4" >آیا مایل به حذف درخواست {this.props.ReqNum} هستید؟</td></tr>
                <tr><td style={this.styles.table} colSpan="4"><button className="btn btn-danger" style={{ 'marginLeft': '10px' }} onClick={this.props.yes}>بله</button><button className="btn btn-danger" onClick={this.props.no}>خیر</button></td></tr>
            </React.Fragment>
        )
    }
}
//////////////////




// WEBPACK FOOTER //
// ./src/pages/TableOfRequest.js